/* ── Shared mock panel header row ── */
const MetaRow = ({ label, right }) => (
  <div className="flex items-center justify-between gap-3">
    <span className="flex items-center gap-2 text-[10px] font-medium uppercase tracking-[0.12em]  text-white">
      <span className="inline-flex h-3 w-3 items-center justify-center rounded-full bg-[#3DDC9733]">
        <span className="h-1.5 w-1.5 rounded-full bg-[#051A6A]" />
      </span>
      {label}
    </span>
    {right && (
      <span className="shrink-0 text-[9px] font-medium uppercase tracking-[0.14em] text-[#A59881] ">
        {right}
      </span>
    )}
  </div>
);

export default MetaRow;
